
import { Component, Prop, Vue } from 'vue-property-decorator';
import { IPagination } from '@/types';
import { UserModule } from '@/store/modules/user';
import eventBus from '@/utils/eventBus';
import { addGroupPush, editGroupPush, delGroupPush, groupPushList } from '@/api/group';

import GroupSearch from './components/GroupSearch.vue';
import GroupStep2 from './components/GroupStep2.vue';
import DialogScheduling from '@/components/DialogScheduling/index.vue';


@Component({
  name: 'GroupsPushDepartment',
  components: {
    GroupSearch,
    GroupStep2,
    DialogScheduling,

    // DialogGroupStep2,
    // DialogDepartment,
    // DialogDept,
  }
})
export default class extends Vue {
  private pagination: IPagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private searchParams: any = {}
  private tableData:any = [];
  private listLoading = false;
  private editData: any={};
  // private selectDepartment:any=[]
  // private dialogSelectedVisible= false
  // private selectedDeptvisible = false
  private selectedDept:any={}
  private isDef=false;

  created() {
    let that = this;
    eventBus.$on('groupSearch', function(data:any) {
      that.searchParams = data;
      that.getList();
    });

    this.$once('hook:beforeDestroy', () => {
      eventBus.$off('groupSearch');
    });
    that.getList();
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.getList();
  }

  private getList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      group_type: 9,
      customer_department_name: this.searchParams.deptCustomer,
      servicer_dept_name: this.searchParams.dept,
      engineer_user_name: this.searchParams.engineer,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize
    };
    groupPushList(params)
      .then((res: any) => {
        if (res.data) {
          this.pagination.total = res.data.count;
          this.tableData = res.data.list;
          for (let index = 0; index < this.tableData.length; index++) {
            if (this.tableData[index].group_push) {
              let aL:any = this.tableData[index].group_push.department_list;
              this.tableData[index].group_push.deptList = aL && aL.length > 0 ? aL.slice(1) : [];
            }
          }
        } else {
          this.pagination.total = 0
          this.tableData = [];
        }

        this.listLoading = false;
      })
      .catch((err: any) => {
        this.tableData = [];
        this.pagination.total = 0
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  //= =========================新版
  private dialogGroupStepVisible = false
  private groupPushType: any = {
    type: 9,
  }
  private selectedGroupData(val: any) {
    this.getList();
  }
  private closeGroupStepVisible(val: any) {
    this.dialogGroupStepVisible = val
  }

  //= ============================

  private addGroupHandle() {
    this.isDef = false;
    this.editData = {};
    this.dialogGroupStepVisible = true;

    // this.selectDepartment = [];
    // this.selectedDept = {};
    // this.deptSelected = {};
    // this.pushName = '';
    // this.pushId = '';
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入1-30位的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^\S.{1,29}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   this.dialogSelectedVisible = true;
    // }).catch(() => {
    // });
  }
  private addDefOperationhandle() {
    this.isDef = true;
    this.editData = {};
    this.dialogGroupStepVisible = true;
    // this.selectDepartment = [];
    // this.selectedDept = {};
    // this.deptSelected = {};
    // this.pushName = '';
    // this.pushId = '';
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入1-30位的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^\S.{1,29}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   this.selectedDeptvisible = true;
    // }).catch(() => {
    // });
  }
  private editGroupHandle(val: any) {
    this.editData = val;
    if (parseInt(val.is_default_group) === 1) {
      this.isDef = true;
    } else {
      this.isDef = false;
    }
    this.dialogGroupStepVisible = true;

    // if (val.group_push) {
    //   if (parseInt(val.sub_type) === 1) {
    //     this.deptSelected.dept_id = val.group_push.servicer_dept_id;
    //     this.deptSelected.name = val.group_push.servicer_dept_name;
    //   } else {
    //     this.selectedDept = val.group_push;
    //   }
    // }
    // this.pushId = val.id;
    // this.pushName = this.editData.group_name;
    // this.$prompt('名称', '群组名称', {
    //   confirmButtonText: '下一步',
    //   cancelButtonText: '取消',
    //   inputErrorMessage: '请输入1-30位的名称',
    //   inputPlaceholder: '请输入群组名称(不超过30字)',
    //   inputPattern: /^\S.{1,29}$/,
    //   inputValue: this.pushName
    // }).then(({ value }: any) => {
    //   this.pushName = value;
    //   if (parseInt(val.is_default_group) === 1) {
    //     this.isDef = true;
    //     this.selectedDeptvisible = true;
    //   } else {
    //     this.isDef = false;
    //     this.selectDepartment = this.editData.group_push.department_list;
    //     this.dialogSelectedVisible = true;
    //   }
    // }).catch(() => {
    // });
  }
  private deleteGroupHandle(val:any) {
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        const params = {
          user_id: UserModule.getUserId,
          company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
          id: val.id
        };
        delGroupPush(params)
          .then((res) => {
            this.showSuccessMsg('删除成功');
            this.getList();
          })
          .catch((err) => {
            this.showErrorMsg(err.msg);
          });
      })
      .catch(() => {});
  }
  // private changeDeptChange(value:any) {
  //   this.selectDepartment = value;
  // }
  // private nextHandle(val:number) {
  //   if (!this.selectDepartment || this.selectDepartment.length < 1) {
  //     this.showErrorMsg('请选择部门');
  //     return;
  //   }
  //   if (val === 1) {
  //     this.selectedDeptvisible = true;
  //   } else {
  //     // 排班
  //     this.departmentVisible = true;
  //   }
  // }
  // private closeGroupTwoVisible(val: any) {
  //   this.selectedDeptvisible = val;
  // }
  // private groupNextTwoVisible(val: any) {
  //   this.selectedDept = val;
  //   this.add(this.pushName, this.isDef, 0);
  // }

  // private add(name: any, isDefault:boolean, subType:number) {
  //   let params:any = {
  //     user_id: UserModule.getUserId,
  //     company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     servicer_company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
  //     servicer_company_name: UserModule.getCompanyName,
  //     group_type: 9,
  //     sub_type: subType
  //   };
  //   if (this.selectDepartment) {
  //     if (this.selectDepartment && this.selectDepartment.length > 0) {
  //       params.department_list = JSON.stringify(this.selectDepartment);
  //     }

  //     if (this.selectedDept.servicer_dept_id) {
  //       params.servicer_dept_id = this.selectedDept.servicer_dept_id;
  //       params.servicer_dept_name = this.selectedDept.servicer_dept_name;
  //     }
  //     if (this.selectedDept.engineer_user_id) {
  //       params.engineer_user_id = this.selectedDept.engineer_user_id;
  //       params.engineer_user_name = this.selectedDept.engineer_user_name;
  //     }
  //   }
  //   params.group_name = name;
  //   params.is_default_group = isDefault ? '1' : '0';
  //   if (this.editData && this.editData.id) {
  //     params.id = this.editData.id;
  //     editGroupPush(params).then(res => {
  //       if (subType === 1) {
  //         this.dialogSchedulingVisible = true;
  //         this.groupData = {
  //           group_push_id: this.pushId,
  //           group_push_name: this.pushName
  //         };
  //       } else {
  //         this.showSuccessMsg((res as any).msg);
  //         this.dialogSelectedVisible = false;
  //         this.selectedDeptvisible = false;
  //         this.getList();
  //       }
  //     }).catch(err => {
  //       this.showErrorMsg(err.msg);
  //     });
  //   } else {
  //     addGroupPush(params).then(res => {
  //       if (subType === 1) {
  //         if (res.data && res.data.group_cs) {
  //           this.pushId = res.data.group_cs.id;
  //         }
  //         this.dialogSchedulingVisible = true;
  //         this.groupData = {
  //           group_push_id: this.pushId,
  //           group_push_name: this.pushName
  //         };
  //       } else {
  //         this.showSuccessMsg((res as any).msg);
  //         this.dialogSelectedVisible = false;
  //         this.selectedDeptvisible = false;
  //         this.getList();
  //       }
  //     }).catch(err => {
  //       this.showErrorMsg(err.msg);
  //     });
  //   }
  // }

  // 排班
  // private departmentVisible=false;
  // private deptType=2
  private deptSelected:any={};
  private dialogResultSchedulingHandle:any={}

  // private departmentDialogClose(val:any) {
  //   this.departmentVisible = val;
  // }
  // private departmentSelected(val:any) {
  //   this.deptSelected = val;
  //   this.selectedDept.servicer_dept_id = val.dept_id;
  //   this.selectedDept.servicer_dept_name = val.name;
  // this.add(this.pushName, this.isDef, 1);
  // }

  // 设置排班
  private pushName=''
  private pushId=''
  private setSchedulinghandle(val:any) {
    this.editData = val;
    this.pushId = val.id;
    this.isDef = parseInt(val.is_default_group) === 1;
    this.pushName = val.group_name;
    if (val.group_push) {
      if (parseInt(val.sub_type) === 1) {
        this.deptSelected.dept_id = val.group_push.servicer_dept_id;
        this.deptSelected.name = val.group_push.servicer_dept_name;
      } else {
        this.selectedDept = val.group_push;
      }
    }
    this.groupData = {
      group_push_id: this.pushId,
      group_push_name: this.pushName
    };
    this.dialogSchedulingVisible = true;
  }
  // 排班 弹窗
  private dialogSchedulingVisible=false
  private groupData:any={}

  private dialogSchedulingConfirm(val:any) {
    this.dialogSchedulingVisible = false;
    // this.departmentVisible = false;
    // this.dialogSelectedVisible = false;
    this.getList();
  }
  private dialogSchedulingClose(val:boolean) {
    this.dialogSchedulingVisible = val;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
